
import React, { useState, useRef, useEffect } from "react";

function SearchableDropdown({ item, handle_onchange ,placeholder,}) {
  
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  const filteredOptions = item.attribute_value.filter((attribute) =>
    attribute?.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleOutsideClick = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  React.useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  //  console.log("searchTerm",searchTerm)
  const handleOptionSelect = (option) => {
  
    setSearchTerm(option.name); 
    setIsOpen(false); 
    // console.log("option",option)
    handle_onchange(item.attribute_name, option.value,option); 
  };
 

  return (
    <div className="relative w-full" ref={dropdownRef}>
    
      <input
        type="text"
        className="rounded-md inputBox1 w-full p-2"
        placeholder={placeholder?placeholder:"Please select"}
        value={searchTerm}
        onClick={() => setIsOpen(!isOpen)} 
        onChange={(e) => {
          // console.log("e",e.target.value.length); 
          // console.log("item",item)
           if(e?.target?.value?.length>0){
            setSearchTerm(e.target.value); 
            setIsOpen(true); 
           }else{
            setSearchTerm("");
            setIsOpen(false)
            handle_onchange(item.attribute_name,null,null)
           }
          
        }}
      />

      {/* Dropdown menu */}
      {isOpen && (
        <ul className="absolute z-10 bg-white border rounded-md mt-1 w-full max-h-40 overflow-auto shadow-lg">
          {filteredOptions.length > 0 ? (
            filteredOptions.map((attribute, index) => (
              <li
                key={index}
                className="p-2 hover:bg-gray-200 cursor-pointer flex items-center"
                onClick={() => handleOptionSelect(attribute)}
              >
                <span
                  className="w-4 h-4 rounded-full mr-2"
                  style={{ backgroundColor: attribute.value }}
                ></span>
                {attribute.name}
              </li>
            ))
          ) : (
            <li className="p-2 text-gray-500">No records found</li>
          )}
        </ul>
      )}
    </div>
  );
}

export default SearchableDropdown;
